import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    Authorization: "Basic VBvxXwkKyG3ipBDRB68iXcNhk7e1KsD7",
  }),
};

@Injectable({
  providedIn: "root",
})
export class StockSimulationService {
  constructor(protected httpClient: HttpClient) {}

  public postCheckStock(
    param: any,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.httpClient
      .post<any>(
        "http://staging.radyalabs.id/eZB2B/api/product/check-stock-bulk",
        // "https://app.aplcare.com/eZB2B_Web_UAT/api/product/check-stock-bulk",
        // "https://app.aplcare.com/eZB2B/api/product/check-stock-bulk",
        param,
        httpOptions
      )
      .subscribe(
        (resp) => {
          onSuccess(resp);
        },
        (err) => {
          onError(err);
        }
      );
  }
}
